module.exports = __webpack_public_path__ + "static/img/reward-bg.20982c24.webp";